<template>
  <Notes
    v-if="commentableId && commentableType"
    :commentable-id="commentableId"
    :commentable-type="commentableType"
  />
</template>

<script>
import { mapState } from "vuex";

import Notes from "@/Comments/Comments.vue";
export default {
  components: {
    Notes
  },
  props: {
    commentableIdOverride: { type: Number, default: null },
    commentableTypeOverride: { type: String, default: null }
  },
  computed: {
    ...mapState({
      currentUser: "currentUser"
    }),
    commentableId() {
      return this.commentableIdOverride || this.currentUser?.id;
    },
    commentableType() {
      return this.commentableTypeOverride || "User";
    }
  }
};
</script>

<style lang="scss" scoped></style>
